import * as React from "react"

export const DownArrow = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="ionicon"
        viewBox="0 0 512 512"
        width={props.size}
        height={props.size}
        {...props}
    >
        <title>{"Chevron Down"}</title>
        <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={48}
            d="m112 184 144 144 144-144"
        />
    </svg>
)


export const OldExitIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="ionicon"
        viewBox="0 0 512 512"
        width={props.size}
        height={props.size}
        {...props}
    >
        <title>{"Close"}</title>
        <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={32}
            d="M368 368 144 144m224 0L144 368"
        />
    </svg>
)


export const UpArrow = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="ionicon"
        viewBox="0 0 512 512"
        width={props.size}
        height={props.size}
        {...props}
    >
        <title>{"Chevron Up"}</title>
        <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={48}
            d="m112 328 144-144 144 144"
        />
    </svg>
)


export const SearchIcon = (props) => (
    <svg width={props.size} height={props.size} xmlns="http://www.w3.org/2000/svg" {...props}>
        <title>{"ic_search"}</title>
        <path
            d="M12.786 11.183s1.336-2.373 1.336-4.122a7.061 7.061 0 1 0-7.06 7.061c1.748 0 4.117-1.36 4.117-1.36l.77.817L17.382 19 19 17.381l-5.42-5.431-.794-.767Zm-5.725.767A4.882 4.882 0 0 1 2.173 7.06 4.882 4.882 0 0 1 7.06 2.173 4.882 4.882 0 0 1 11.95 7.06 4.882 4.882 0 0 1 7.06 11.95Z"
            fill={props.color || "#317C8C"}
            fillRule="evenodd"
        />
    </svg>
)


export const ExitIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.size} height={props.size} {...props} viewBox="0 0 12 12">
        <title>{"Exit"}</title>
        <path
            strokeWidth={props.strokeWidth}
            d="M10.052 8.95c0-.295-.116-.571-.324-.78L7.043 5.486l2.685-2.684a1.09 1.09 0 0 0 .323-.78c0-.295-.115-.57-.321-.777A1.092 1.092 0 0 0 8.95.92c-.295 0-.573.115-.779.323L5.485 3.928 2.801 1.243A1.092 1.092 0 0 0 2.02.92c-.294 0-.57.114-.78.324a1.1 1.1 0 0 0 0 1.556L3.93 5.485 1.242 8.171a1.1 1.1 0 0 0 .001 1.558c.43.428 1.127.428 1.558 0l2.684-2.686L8.17 9.728c.208.208.485.322.78.322.295 0 .572-.114.778-.322.208-.208.324-.484.324-.779Z"
            fill="#44474A"
            fillRule="evenodd"
        />
    </svg>
)

export const ExportIcon = (props) => (
    <svg width={props.size} height={props.size} xmlns="http://www.w3.org/2000/svg" {...props}>
        <title>{"Export"}</title>
        <g
            stroke="#707579"
            strokeWidth={1.5}
            fill="none"
            fillRule="evenodd"
            opacity={0.501}
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M8 10.993V1M10 2.999 8 1M8 1 6 2.999M15 10v3.997a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V10" />
        </g>
    </svg>
)

export const InventoryIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.size} height={props.size} color={props.color} {...props}>
        <title>{"Group"}</title>
        <g fillRule="nonzero" fill="none">
            <path
                d="M17.25 6.242C15.192 7.212 12.369 7.75 9 7.75c-3.369 0-6.192-.538-8.25-1.508V16c0 1.81 3.624 3.25 8.25 3.25 4.626 0 8.25-1.44 8.25-3.25V6.242Z"
                stroke={props.color}
                strokeWidth={1.5}
            />
            <path
                d="M9 5c5.195 0 7.705-1.305 8.599-2.264C16.404.935 12.687 0 9 0 5.313 0 1.596.937.401 2.737 1.295 3.694 3.805 5 9 5"
                fill={props.color}
            />
        </g>
    </svg>
)


export const CheckButton = ({ size = 18, color = "#317C8C", selected, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <title>{"ic_tick"}</title>
        <circle
            cx="12"
            cy="12"
            r="10"
            stroke={color}
            strokeWidth="2"
        />
        {selected && (
            <path
                d="M8 12.5l3 3 5-5"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        )}
    </svg>
);


export const Lock = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="ionicon"
        viewBox="0 0 512 512"
        width={props.size} height={props.size} color={props.color}
        {...props}
    >
        <title>{"Lock Closed"}</title>
        <path
            d="M336 208v-95a80 80 0 0 0-160 0v95"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={32}
        />
        <rect
            x={96}
            y={208}
            width={320}
            height={272}
            rx={48}
            ry={48}
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={32}
        />
    </svg>
)

export const Exit = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 25"
        width={props.size} height={props.size} color={props.color}
        {...props}>
        <title>{"Exit"}</title>
        <path
            d="M17.052 15.95c0-.295-.116-.571-.324-.78l-2.685-2.685 2.685-2.684a1.09 1.09 0 0 0 .323-.78c0-.295-.115-.57-.321-.777a1.092 1.092 0 0 0-.78-.324c-.295 0-.573.115-.779.323l-2.686 2.685-2.684-2.685a1.092 1.092 0 0 0-.78-.323c-.294 0-.57.114-.78.324a1.1 1.1 0 0 0 0 1.556l2.687 2.685-2.686 2.686a1.1 1.1 0 0 0 .001 1.558c.43.428 1.127.428 1.558 0l2.684-2.686 2.685 2.685c.208.208.485.322.78.322.295 0 .572-.114.778-.322.208-.208.324-.484.324-.779Z"
            fill={props.color}
            fillRule="evenodd"
        />
    </svg>
)

export const LeftArrow = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="ionicon"
        viewBox="0 0 512 512"
        width={props.size} height={props.size} color={props.color}
        {...props}
    >
        <title>{"Play Skip Back"}</title>
        <path
            d="M400 111v290c0 17.44-17 28.52-31 20.16L121.09 272.79c-12.12-7.25-12.12-26.33 0-33.58L369 90.84c14-8.36 31 2.72 31 20.16z"
            fill="none"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeWidth={32}
        />
        <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeMiterlimit={10}
            strokeWidth={32}
            d="M112 80v352"
        />
    </svg>
)


export const HideIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="ionicon"
        viewBox="0 0 512 512"
        width={props.size} height={props.size} color={props.color}
        {...props}
    >
        <title>{"Caret Back"}</title>
        <path d="M321.94 98 158.82 237.78a24 24 0 0 0 0 36.44L321.94 414c15.57 13.34 39.62 2.28 39.62-18.22v-279.6c0-20.5-24.05-31.56-39.62-18.18z" />
    </svg>
)
export const ExpandIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="ionicon"
        viewBox="0 0 512 512"
        width={props.size} height={props.size} color={props.color}
        {...props}
    >
        <title>{"Caret Forward"}</title>
        <path d="m190.06 414 163.12-139.78a24 24 0 0 0 0-36.44L190.06 98c-15.57-13.34-39.62-2.28-39.62 18.22v279.6c0 20.5 24.05 31.56 39.62 18.18z" />
    </svg>
)

export const RightArrow = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="ionicon"
        viewBox="0 0 512 512"
        width={props.size} height={props.size} color={props.color}
        {...props}
    >
        <title>{"Chevron Forward"}</title>
        <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={48}
            d="m184 112 144 144-144 144"
        />
    </svg>
)

export const EmptyPlaceHolder = (props) => (
    <svg width={138} height={127} xmlns="http://www.w3.org/2000/svg" {...props}>
        <title>{"Report analysis _Two Color (1)"}</title>
        <g fill="none" fillRule="evenodd">
            <ellipse
                fill="#E6E6E6"
                opacity={0.45}
                cx={72.225}
                cy={120.997}
                rx={65.349}
                ry={5.926}
            />
            <path
                d="M52.697 116.677s1.166 1.528.407 2.96c-.759 1.432.347 2.66 1.483 1.65 1.135-1.008 1.589-5.201 1.589-5.201l-2.583-1.493-.896 2.084ZM62.313 96.297s-.509 1.85.78 2.883c1.288 1.035.718 2.584-.724 2.1-1.441-.484-3.489-4.168-3.489-4.168l1.793-2.38 1.64 1.565Z"
                fill="#007A8E"
            />
            <path
                fill="#A5A5A5"
                d="m82.814 121.65-2.424-1.804 10.58-14.24V81.077h3.02v25.526z"
            />
            <path
                fill="#A5A5A5"
                d="m90.644 106.136 2.445-1.766 11.19 15.503-2.444 1.766z"
            />
            <path fill="#E6E6E6" d="M66.398 8.198h52.162V81.99H66.398z" />
            <path fill="#C9C9C9" d="M66.398 77.628h52.162v9.915H66.398z" />
            <path
                fill="#A5A5A5"
                opacity={0.39}
                d="M80.426 57.08h24.107v5.09H80.426z"
            />
            <path
                fill="#A5A5A5"
                opacity={0.13}
                d="M80.426 65.482h24.107v5.09H80.426z"
            />
            <path fill="#FFD200" d="M105.302.036h27.525v17.547h-27.525z" />
            <path fill="#24285B" d="M110.732 10.297h3.734v3.735h-3.734z" />
            <path
                d="M42.276 25.271s18.066-1.258 16.604 20.585C57.42 67.698 82.005 66.48 82.005 66.48v5.044S48.388 75.942 45.332 57.08c-3.056-18.862-3.056-31.809-3.056-31.809Z"
                fill="#007A8E"
            />
            <path
                d="M87.19 69.889s1.945 5.518-5.185 6.282c-7.131.764-1.528 5.803-6.495 11.372H66.98L65.706 69.36l21.484.53Z"
                fill="#000"
                opacity={0.08}
            />
            <path
                d="M42.276 25.271s18.066-1.258 16.604 20.585C57.42 67.698 82.005 66.48 82.005 66.48v5.044S48.388 75.942 45.332 57.08c-3.056-18.862-3.056-31.809-3.056-31.809Z"
                fill="#FFF"
                opacity={0.46}
            />
            <path
                fill="#24285B"
                d="M117.022 6.287h3.734v7.75h-3.734zM123.664 3.587h3.734v10.445h-3.734z"
            />
            <ellipse fill="#FFF" cx={92.482} cy={35.085} rx={14.007} ry={14.011} />
            <path
                d="M92.482 21.073v14.012l13.711-2.854s-1.91-11.25-13.711-11.158Z"
                fill="#FFD200"
            />
            <path
                d="m92.482 35.085-7.788 11.647s7.849 5.976 16.94-1.05c0 0 6.225-4.509 4.585-13.45l-13.737 2.853Z"
                fill="#24285B"
            />
            <path
                d="M30.128 14.067s.662 2.803.463 4.76a1.447 1.447 0 0 1-1.594 1.283 3.189 3.189 0 0 1-2.817-2.038l-1.222-2.338a2.584 2.584 0 0 1 .728-2.894c1.442-1.391 4.126-.5 4.442 1.227Z"
                fill="#F4A28C"
            />
            <path
                fill="#F4A28C"
                d="m25.202 17.196.887 9.385 5.134-.856-2.705-6.486z"
            />
            <path
                d="M24.922 17.996a.27.27 0 0 0 .24.229 1.91 1.91 0 0 0 2.006-1.146 2.395 2.395 0 0 0-.382-2.609c.89.036 1.78-.032 2.654-.204.296-.05.58-.152.84-.3l.423-2.242s-2.18-1.35-3.346-2.242c-1.166-.892-2.093.871-3.825 1.106-1.732.234-1.336 2.24-1.12 2.415a8.83 8.83 0 0 1 2.51 4.993Z"
                fill="#24285B"
            />
            <path
                d="M30.381 9.83c.906.708 1.45 1.8 1.48 2.968 0 1.017-.418 2.076-2.128 2.27-3.407.385-4.557.385-4.557.385s3.763 9.553-2.893 8.875c-6.656-.677-4.14-6.464-1.225-11.672 2.63-4.697 6.091-5.473 9.323-2.826Z"
                fill="#24285B"
            />
            <path
                d="M27.464 16.946s-.183-1.09-1.019-.886c-.835.203-.535 1.773.606 1.773l.413-.887ZM30.454 15.85l.957.964a.459.459 0 0 1-.183.754l-1.06.367.286-2.084Z"
                fill="#F4A28C"
            />
            <path
                d="M28.865 20.11s-.663.117-2.14-.51c0 0 .469 1.825 2.95 2.4l-.81-1.89Z"
                fill="#CE8172"
                opacity={0.31}
            />
            <path
                d="M10.1 46.472c-2.73-7.683-3.733-11.387 9.102-18.765 6.112-3.516 15.75-4.04 25.167-2.038 18.693 3.99 3.056 28.293 7.813 41.443L30.978 75.06S16.055 63.18 10.1 46.472Z"
                fill="#007A8E"
            />
            <path
                d="M30.978 75.066s7.905 31.915 20.807 41.88l3.734-1.88S41.496 92.899 46.794 81.75a50.45 50.45 0 0 0 1.905-4.794l3.483-9.839-21.204 7.949Z"
                fill="#24285B"
            />
            <path
                d="M24.79 35.783s5.603 5.283 2.109 14.108c-2.415 6.068 2.857 12.508 9.168 10.903.188-.05.387-.102.585-.163 9.296-2.802 14.563-.086 14.563-.086s.152 5.548.947 6.572l-21.204 7.949-.51-.327-7.324-7.286s-5.404-6.236-7.844-10.43c-2.44-4.192 9.51-21.24 9.51-21.24Z"
                fill="#000"
                opacity={0.08}
            />
            <path
                d="M52.182 67.117s25.498.673 18.872 15.469a89.482 89.482 0 0 1-7.987 14.266l-4.151-1.493S73.687 68.05 41.598 81.76l10.584-14.643Z"
                fill="#24285B"
            />
            <path
                d="M24.265 35.039c-3.565-4.53-10.4-4.637-14.343-.438-6.621 7.03-15.061 20.61-5.307 38.06 10.064 18.006 36.983-5.544 36.983-5.544l-2.633-5.467s-26.231 13.757-24.958 0c1.034-11.178 16.594-18.556 10.258-26.611Z"
                fill="#007A8E"
            />
            <path
                d="M24.265 35.039c-3.565-4.53-10.4-4.637-14.343-.438-6.621 7.03-15.061 20.61-5.307 38.06 10.064 18.006 36.983-5.544 36.983-5.544l-2.633-5.467s-26.231 13.757-24.958 0c1.034-11.178 16.594-18.556 10.258-26.611Z"
                fill="#FFF"
                opacity={0.46}
            />
            <path
                d="m39.78 63.347 6.698-2.716s3.351 4.586-4.88 6.486l-1.818-3.77Z"
                fill="#F4A28C"
            />
            <path
                fill="#FFD200"
                d="m53.736 59.928-1.034-15.835-19.04 4.667 1.518 13.344-8.694 2.262L27 66.48z"
            />
            <ellipse fill="#FFF" cx={44.221} cy={53.885} rx={1.961} ry={1.962} />
            <path
                d="M82.005 68.03s3.24-1.02 5.185.753c1.945 1.773-5.185 2.206-5.185 2.206v-2.96Z"
                fill="#F4A28C"
            />
            <path
                d="M20.883 26.851s-.417-3.159 5.837-3.923c6.255-.764 9.168-1.865 9.943 1.676.01 0-2.649 5.151-15.78 2.247Z"
                fill="#007A8E"
            />
            <path
                d="M20.883 26.851s-.417-3.159 5.837-3.923c6.255-.764 9.168-1.865 9.943 1.676.01 0-2.649 5.151-15.78 2.247Z"
                fill="#FFF"
                opacity={0.46}
            />
        </g>
    </svg>
)


export const Alert = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="ionicon"
        viewBox="0 0 512 512"
        width={props.size} height={props.size} color={props.color}
        {...props}
    >
        <path
            d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
            fill="none"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeWidth={32}
        />
        <path
            d="M250.26 166.05 256 288l5.73-121.95a5.74 5.74 0 0 0-5.79-6h0a5.74 5.74 0 0 0-5.68 6z"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={32}
        />
        <path d="M256 367.91a20 20 0 1 1 20-20 20 20 0 0 1-20 20z" />
    </svg>
)


export const WarningIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="ionicon"
        viewBox="0 0 512 512"
        width={props.size} height={props.size} color={props.color}
        {...props}
    >
        <title>{"Warning"}</title>
        <path
            d="M85.57 446.25h340.86a32 32 0 0 0 28.17-47.17L284.18 82.58c-12.09-22.44-44.27-22.44-56.36 0L57.4 399.08a32 32 0 0 0 28.17 47.17z"
            fill={props.color}
            stroke={"white"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={32}
        />
        <path
            d="m250.26 195.39 5.74 122 5.73-121.95a5.74 5.74 0 0 0-5.79-6h0a5.74 5.74 0 0 0-5.68 5.95z"
            fill={props.color}
            stroke={"white"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={32}
        />
        <path d="M256 397.25a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
            fill={"white"}
            stroke={"white"}
        />
    </svg>
)

export const ToggleOff = (props) => (
    <svg width={props.size} height={props.size} color={props.color} xmlns="http://www.w3.org/2000/svg" {...props}>
        <title>{"Off"}</title>
        <g fill="none" fillRule="evenodd">
            <rect
                stroke="#DBDBDB"
                strokeWidth={0.8}
                fill="#F2F2F2"
                fillRule="nonzero"
                x={0.4}
                y={0.4}
                width={36.8}
                height={24.8}
                rx={12.4}
            />
            <rect
                stroke="#DBDBDB"
                strokeWidth={0.8}
                fill="#FFF"
                fillRule="nonzero"
                x={0.4}
                y={0.4}
                width={24.8}
                height={24.8}
                rx={12.4}
            />
            <path
                d="m15.4 15.4-5.1-5.1M10.2 15.4l5.1-5.1"
                stroke="#767676"
                strokeWidth={1.6}
                strokeLinecap="round"
            />
        </g>
    </svg>
)

export const ToggleOn = (props) => (
    <svg width={props.size} height={props.size} color={props.color} xmlns="http://www.w3.org/2000/svg" {...props}>
        <title>{"On"}</title>
        <g stroke="#317C8C" fill="none" fillRule="evenodd">
            <rect
                strokeWidth={0.8}
                fill="#317C8C"
                fillRule="nonzero"
                transform="matrix(-1 0 0 1 37.6 0)"
                x={0.4}
                y={0.4}
                width={36.8}
                height={24.8}
                rx={12.4}
            />
            <rect
                strokeWidth={0.8}
                fill="#FFF"
                fillRule="nonzero"
                transform="matrix(-1 0 0 1 49.6 0)"
                x={12.4}
                y={0.4}
                width={24.8}
                height={24.8}
                rx={12.4}
            />
            <g strokeLinecap="round" strokeWidth={1.6}>
                <path d="m23.4 15.546 5.1-5.1M23.346 15.491 20.8 12.946" />
            </g>
        </g>
    </svg>
)

export const DeleteIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="ionicon"
        viewBox="0 0 512 512"
        width={props.size} height={props.size} color={props.color}
        {...props}
    >
        <title>{"Delete"}</title>
        <path
            d="m112 112 20 320c.95 18.49 14.4 32 32 32h184c17.67 0 30.87-13.51 32-32l20-320"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={32}
        />
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeMiterlimit={10}
            strokeWidth={32}
            d="M80 112h352"
        />
        <path
            d="M192 112V72h0a23.93 23.93 0 0 1 24-24h80a23.93 23.93 0 0 1 24 24h0v40m-64 64v224m-72-224 8 224m136-224-8 224"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={32}
        />
    </svg>
)


export const Clipboard = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg"
        className="ionicon"

        width={props.size} height={props.size} color={props.color}
        {...props}>
        <title>{"ic_Work-Order-Search"}</title>
        <g fill="none" fillRule="evenodd">
            <path
                d="M14.667 5.356h-1.334C13.333 4.606 12.737 4 12 4s-1.333.607-1.333 1.356H9.333v2.032h5.334V5.356Z"
                fill={props.color}
            />
            <path
                d="M16.667 6.747H16V8.78H8V6.747h-.667C6.597 6.747 6 7.354 6 8.103v9.486c0 .748.597 1.355 1.333 1.355h9.334c.736 0 1.333-.607 1.333-1.355V8.103c0-.75-.597-1.356-1.333-1.356Z"
                stroke={props.color}
                strokeWidth={1.05}
            />
            <path
                stroke={props.color}
                strokeWidth={0.5}
                fill="#317C8C"
                d="m11.475 15.319-1.946-1.86.743-.709 1.203 1.15 2.253-2.153.743.71z"
            />
        </g>
    </svg>
)

export const Location = (props) => (
    <svg

        xmlns="http://www.w3.org/2000/svg"
        width={props.size} height={props.size} color={props.color}
        {...props}
    >
        <title>{"Location"}</title>
        <path
            d="M12.455 11.4c-.819 0-1.485-.704-1.485-1.567 0-.86.666-1.564 1.485-1.564.818 0 1.484.703 1.484 1.564 0 .863-.666 1.567-1.484 1.567Zm0-4.198c-1.377 0-2.496 1.18-2.496 2.63 0 1.454 1.12 2.634 2.496 2.634s2.496-1.18 2.496-2.633c0-1.45-1.12-2.63-2.496-2.63Zm4.317 4.034c-.111.466-.51 1.383-.829 1.902-.157.277-2.493 4.471-3.493 6.266l-3.722-6.902-.024-.046c-.094-.178-.29-.544-.43-1.01a5.855 5.855 0 0 1-.262-1.695c0-2.584 1.993-4.685 4.443-4.685 2.562 0 4.308 2.165 4.515 4.255.053.53-.01 1.14-.198 1.915Zm1.205-2.025C17.683 6.243 15.309 4 12.455 4 9.447 4 7 6.58 7 9.75c0 .662.102 1.323.31 2.016.17.572.41 1.02.513 1.212l.023.043.002.007 4.155 7.702c.09.167.256.27.436.27h.004a.5.5 0 0 0 .436-.263c.038-.068 3.738-6.707 3.924-7.034.334-.547.796-1.564.95-2.2.218-.906.29-1.631.224-2.292Z"
            fill={props.color}
            fillRule="evenodd"
        />
    </svg>
)


export const Assets = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        style={{
            enableBackground: "new 0 0 512 512",
        }}
        xmlSpace="preserve"
        width={props.size} height={props.size} color={props.color}
        {...props}
    >
        <title>{"Asset"}</title>
        <g fillRule="nonzero" fill="none">
            <path
                d="M6.54 9.38c1.386.633 3.376 1.06 5.96 1.06 2.496 0 4.438-.399 5.816-.995l.144 3.972V16.2c0 .28-.12.524-.317.741-.269.3-.67.546-1.151.753-1.187.511-2.846.766-4.492.766-1.6 0-3.21-.24-4.39-.724-.488-.199-.898-.437-1.186-.724-.206-.205-.346-.434-.377-.697Z"
                stroke={props.color}
                strokeWidth={1.08}
            />
            <path
                d="M12.5 8.5c3.752 0 5.565-.914 6.21-1.585C17.847 5.655 15.163 5 12.5 5s-5.347.655-6.21 1.915c.645.67 2.458 1.585 6.21 1.585"
                fill={props.color}
            />
        </g>
    </svg>
)

export const ServiceEvents = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg"
        width={props.size} height={props.size} color={props.color}
        {...props}>
        <title>{"ic_service-events-Search"}</title>
        <g
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke={props.color}
            strokeWidth={1.2}
        >
            <path d="M9 14.993h3M14 18.99H7a1 1 0 0 1-1-.998V8.997a1 1 0 0 1 1-.999h7a1 1 0 0 1 1 1v8.994a1 1 0 0 1-1 .999ZM9 11.995h3" />
            <path d="M9 5h8a1 1 0 0 1 1 1v9.993" />
        </g>
    </svg>
)




export const DoubleArrow = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 120.64 122.88"
        style={{
            enableBackground: "new 0 0 120.64 122.88",
        }}

        width={props.size} height={props.size} color={props.color}
        {...props}
    >
        <path d="M54.03 108.91a8.288 8.288 0 0 0-2.28 5.85c.03 2.11.84 4.2 2.44 5.79l.12.12c1.58 1.5 3.6 2.23 5.61 2.2 2.01-.03 4.01-.82 5.55-2.37 17.66-17.66 35.13-35.61 52.68-53.4.07-.05.13-.1.19-.16a8.335 8.335 0 0 0 2.28-5.87 8.323 8.323 0 0 0-2.45-5.8l-.27-.26C100.43 37.47 82.98 19.87 65.46 2.36A7.956 7.956 0 0 0 59.92 0c-2.01-.03-4.03.7-5.61 2.21l-.15.15a8.318 8.318 0 0 0-2.41 5.76c-.03 2.1.73 4.22 2.28 5.85l47.22 47.27-47.22 47.67zm-51.77-2A8.265 8.265 0 0 0 0 112.74c.03 2.11.84 4.2 2.44 5.79l.12.12c1.57 1.5 3.6 2.23 5.61 2.21 2.01-.03 4.02-.82 5.55-2.37C31.01 101.2 48.87 84.2 66.39 67.12c.07-.05.14-.11.21-.17a8.335 8.335 0 0 0 2.28-5.87 8.323 8.323 0 0 0-2.45-5.8C48.94 38.33 31.36 21.44 13.83 4.51l-.12-.13a7.945 7.945 0 0 0-5.54-2.35c-2.01-.03-4.03.7-5.61 2.2l-.15.15A8.336 8.336 0 0 0 0 10.14c-.03 2.1.73 4.22 2.28 5.85l47.18 45.24-47.2 45.68z" />
    </svg>
)

export const B3Icon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={props.size} height={props.size}
        {...props}
    >
        <title>{"ic_B3"}</title>
        <defs>
            <filter
                id="a"
                width="105.7%"
                height="113.5%"
                x="-3%"
                y="-3.6%"
                filterUnits="objectBoundingBox"
            >
                <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur
                    in="shadowOffsetOuter1"
                    result="shadowBlurOuter1"
                    stdDeviation={0.5}
                />
                <feColorMatrix
                    in="shadowBlurOuter1"
                    result="shadowMatrixOuter1"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                />
                <feMerge>
                    <feMergeNode in="shadowMatrixOuter1" />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
            <path id="b" d="M.028.02h10.974v6.53H.028z" />
        </defs>
        <g
            fill="white"
            fillRule="evenodd"
            filter="url(#a)"
            transform="translate(4 4)"
        >
            <path
                fill="white"
                fillRule="nonzero"
                stroke="#FFF"
                strokeWidth={0.974}
                d="M55.406 13.425c.417.407.63.945.636 1.485a2.103 2.103 0 0 1-.597 1.495L44.06 27.525c-.41.4-.942.601-1.474.601s-1.064-.2-1.474-.6L29.764 16.445a2.104 2.104 0 0 1-.636-1.485 2.103 2.103 0 0 1 .597-1.495L41.11 2.345c.41-.4.942-.601 1.474-.601s1.064.2 1.474.6Z"
            />
            <g transform="translate(37.154 14.452)">
                <mask id="c" fill="#fff">
                    <use xlinkHref="#b" />
                </mask>
                <path
                    fill="#FFF"
                    d="M7.56 3.376c.669.315 1.337.63 2.004.947a.193.193 0 0 0 .184.002.883.883 0 0 1 1.09.266c.245.325.209.774-.081 1.083a.326.326 0 0 0-.077.16.874.874 0 0 1-.823.715c-.416.015-.787-.252-.88-.644-.022-.099-.077-.148-.164-.189a2597.314 2597.314 0 0 1-7.356-3.475.181.181 0 0 0-.168-.002c-.323.144-.636.124-.922-.087-.274-.202-.373-.482-.329-.807A.85.85 0 0 1 .264.9.358.358 0 0 0 .348.735c.068-.383.37-.662.777-.71a.872.872 0 0 1 .893.524c.006.015.017.028.017.042.006.175.131.238.274.304.828.386 1.652.78 2.478 1.17.217.103.433.207.652.304.042.018.108.02.148.002A617.569 617.569 0 0 0 8.876.816C8.915.797 8.949.744 8.96.7a.868.868 0 0 1 .56-.628c.48-.182 1.066.133 1.15.625.015.091.05.162.113.232.274.304.29.745.045 1.062a.887.887 0 0 1-1.07.257c-.064-.029-.117-.042-.186-.009-.689.33-1.38.655-2.07.982-.03.015-.059.032-.089.048l-.006.03c.05.026.101.052.153.077Z"
                    mask="url(#c)"
                />
            </g>
            <path
                fill="#FFF"
                stroke="#FFF"
                strokeWidth={0.5}
                d="M42.675 15.53h-1.488c-.359 0-.572-.207-.574-.557 0-.168-.002-.335 0-.503.002-.066-.023-.096-.092-.11-1.013-.218-1.58-.859-1.814-1.812a1.421 1.421 0 0 1-.042-.334c0-.624-.015-1.25.017-1.872.03-.583.245-1.117.6-1.591.507-.677 1.199-1.095 2.012-1.337a4.955 4.955 0 0 1 2.243-.138c.82.135 1.557.446 2.16 1.015.578.546.92 1.219.969 1.996.045.713.047 1.432.005 2.145a2.078 2.078 0 0 1-1.626 1.894c-.064.015-.129.033-.194.036-.093.004-.113.05-.111.13.004.162.002.323 0 .485 0 .343-.217.552-.569.553h-1.496"
            />
            <path
                fill="#FFF"
                d="M42.126 18.846c-.054.031-.086.053-.12.07-.885.417-1.77.836-2.656 1.25a.22.22 0 0 0-.13.164.873.873 0 0 1-1.418.444.828.828 0 0 1-.289-.499.37.37 0 0 0-.087-.174.837.837 0 0 1-.134-.976.878.878 0 0 1 .926-.436c.085.015.164.058.249.08.044.01.1.015.139-.003.537-.248 1.072-.503 1.61-.751a.207.207 0 0 1 .146 0c.138.056 1.589.747 1.764.83Z"
            />
            <path
                fill="#F34135"
                d="M40.445 11.037c.098-.392.466-.636.888-.613.385.022.726.31.772.693.04.334.07.676-.04 1.005-.115.337-.46.547-.846.534-.35-.012-.685-.256-.768-.586-.042-.172-.04-.355-.055-.518.016-.184.009-.355.049-.515ZM44.95 11.542c-.015.166-.012.336-.048.497-.074.336-.394.59-.743.615-.387.027-.733-.175-.87-.513a.603.603 0 0 1-.052-.202c-.008-.258-.025-.519-.003-.775.039-.454.433-.764.908-.74a.84.84 0 0 1 .793.824c.002.098 0 .195 0 .293h.014M42.934 13.5l-.538.02c-.266.01-.375-.112-.333-.367.05-.3.211-.543.427-.753.104-.1.24-.099.345.002.207.2.366.43.418.717l.01.063c.025.24-.08.348-.33.318"
            />
            <g stroke="#FFF">
                <path
                    fill="#F34135"
                    fillRule="nonzero"
                    strokeWidth={0.974}
                    d="M28.114 13.425c.417.407.63.945.636 1.485a2.103 2.103 0 0 1-.597 1.495l-11.386 11.12c-.41.4-.942.601-1.474.601s-1.064-.2-1.474-.6L2.472 16.445a2.104 2.104 0 0 1-.636-1.485 2.103 2.103 0 0 1 .597-1.495l11.386-11.12c.41-.4.942-.601 1.474-.601s1.065.2 1.474.6Z"
                />
                <path
                    fill="#FFF"
                    strokeWidth={0.5}
                    d="M18.017 12.053c.02-.101.05-.202.058-.304a2.275 2.275 0 0 0-.165-1.05c-.06-.148-.039-.26.064-.336a.26.26 0 0 1 .35.024c.273.254.551.505.794.785a8.694 8.694 0 0 1 1.438 2.274c.378.878.564 1.789.474 2.74a4.488 4.488 0 0 1-.78 2.12c-.482.709-1.102 1.283-1.81 1.769-.31.211-.635.399-.956.593-.12.072-.232.06-.32-.02-.092-.084-.114-.196-.052-.32.19-.38.332-.775.421-1.19.102-.47.126-.945.096-1.424a5.55 5.55 0 0 0-.902-2.726c-.22-.337-.508-.631-.766-.945-.007-.009-.015-.018-.024-.023-.046-.024-.092-.046-.137-.068-.015.045-.038.089-.042.134-.067.818-.286 1.59-.735 2.29-.106.165-.233.317-.359.469a.272.272 0 0 1-.323.074c-.11-.054-.156-.178-.145-.307.02-.231.028-.463.033-.695.001-.045-.03-.091-.047-.137h-.042c-.044.096-.09.192-.132.29-.192.442-.464.838-.733 1.237-.55.818-.614 1.681-.246 2.583.06.146.125.29.188.436.054.125.032.24-.06.32-.09.077-.198.087-.322.018-.75-.417-1.465-.878-2.069-1.487-.579-.584-.969-1.263-1.061-2.08a4.372 4.372 0 0 1 .216-1.88c.212-.64.551-1.224.846-1.827.195-.398.366-.804.449-1.24.018-.1.029-.201.044-.301.023-.152.082-.227.196-.247a.275.275 0 0 1 .313.159c.095.189.195.377.264.575.073.209.11.429.166.643.01.038.034.071.051.107.037-.021.088-.033.11-.064.217-.301.439-.6.64-.91.483-.745.881-1.527 1.075-2.395.097-.435.143-.874.075-1.32-.044-.288.135-.421.412-.316.52.199.97.506 1.384.867a6.567 6.567 0 0 1 1.32 1.616c.263.443.475.91.647 1.394.013.035.039.067.059.1l.045-.005"
                />
            </g>
        </g>
    </svg>
)

export const QuickReferenceAll = () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" fill="#0000008a" viewBox="0 -960 960 960" width="24">
        <path d="M200-800v241-1 400-640 200-200Zm80 400h140q9-23 22-43t30-37H280v80Zm0 160h127q-5-20-6.5-40t.5-40H280v80ZM200-80q-33 0-56.5-23.5T120-160v-640q0-33 23.5-56.5T200-880h320l240 240v100q-19-8-39-12.5t-41-6.5v-41H480v-200H200v640h241q16 24 36 44.5T521-80H200Zm460-120q42 0 71-29t29-71q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 42 29 71t71 29ZM864-40 756-148q-21 14-45.5 21t-50.5 7q-75 0-127.5-52.5T480-300q0-75 52.5-127.5T660-480q75 0 127.5 52.5T840-300q0 26-7 50.5T812-204L920-96l-56 56Z" />
    </svg>
)

export const MoveLocation = () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" fill="#0000008a" viewBox="0 -960 960 960" width="24">
        <path d="M440-280q-7 0-12-4t-7-10q-14-42-34-70t-40-54q-20-26-33.5-54T300-540q0-58 41-99t99-41q58 0 99 41t41 99q0 40-13.5 68T533-418q-20 26-40 54t-34 70q-2 6-7 10t-12 4Zm0-112q9-14 18-26t17-23q23-30 34-50t11-49q0-33-23.5-56.5T440-620q-33 0-56.5 23.5T360-540q0 29 11 49t34 50q8 11 17 23t18 26Zm0-98q21 0 35.5-14.5T490-540q0-21-14.5-35.5T440-590q-21 0-35.5 14.5T390-540q0 21 14.5 35.5T440-490Zm0 370q-150 0-255-105T80-480q0-75 28.5-140.5t77-114q48.5-48.5 114-77T440-840q75 0 140.5 28.5t114 77q48.5 48.5 77 114T800-480v8l53-54 57 56-150 150-150-150 57-56 53 53v-7q0-116-82-198t-198-82q-116 0-198 82t-82 198q1 116 82.5 198T440-200q57 0 107-21.5t88-58.5l57 57q-49 48-113.5 75.5T440-120Zm0-420Z" />
    </svg>
)

export const CommentBox = () => (
    <svg width="20px" height="19px" viewBox="0 0 20 19" version="1.1" xmlns="http://www.w3.org/2000/svg" >
        <g id="Inventory" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Inventory---Details" transform="translate(-1177.000000, -258.000000)" fill="#6D7588">
                <path d="M1195.48101,270.644474 C1195.48101,270.695687 1195.38278,270.787871 1195.22785,270.787871 L1186.24051,270.787871 C1186.22835,270.787871 1186.21722,270.792992 1186.20506,270.792992 C1186.17823,270.792992 1186.1519,270.798113 1186.12557,270.803235 C1186.10177,270.803235 1186.07848,270.808356 1186.05519,270.813477 C1186.03089,270.82372 1186.00759,270.828841 1185.9843,270.839084 C1185.96051,270.844205 1185.93671,270.854447 1185.91392,270.86469 C1185.89316,270.874933 1185.87291,270.890296 1185.85266,270.900539 C1185.82886,270.915903 1185.80658,270.931267 1185.7843,270.946631 C1185.77519,270.951752 1185.76456,270.956873 1185.75595,270.967116 L1181.43038,274.592992 L1181.43038,271.556065 C1181.43038,271.130997 1181.09063,270.787871 1180.67089,270.787871 L1178.77215,270.787871 C1178.61772,270.787871 1178.51899,270.695687 1178.51899,270.644474 L1178.51899,259.684906 C1178.51899,259.633693 1178.61772,259.536388 1178.77215,259.536388 L1195.22785,259.536388 C1195.38278,259.536388 1195.48101,259.633693 1195.48101,259.684906 L1195.48101,270.644474 Z M1195.22785,258 L1178.77215,258 C1177.79544,258 1177,258.757951 1177,259.684906 L1177,270.644474 C1177,271.571429 1177.79544,272.324259 1178.77215,272.324259 L1179.91139,272.324259 L1179.91139,276.231806 C1179.91139,276.528841 1180.08152,276.80027 1180.34835,276.928302 C1180.45114,276.974394 1180.56152,277 1180.67089,277 C1180.84506,277 1181.01722,276.938544 1181.15595,276.820755 L1186.51443,272.324259 L1195.22785,272.324259 C1196.20506,272.324259 1197,271.571429 1197,270.644474 L1197,259.684906 C1197,258.757951 1196.20506,258 1195.22785,258 L1195.22785,258 Z" id="2H"></path>
            </g>
        </g>
    </svg>
)

export const PublishedWithChanges = () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" fill="#0000008a" viewBox="0 -960 960 960" width="24">
        <path d="M440-82q-76-8-141.5-41.5t-114-87Q136-264 108-333T80-480q0-91 36.5-168T216-780h-96v-80h240v240h-80v-109q-55 44-87.5 108.5T160-480q0 123 80.5 212.5T440-163v81Zm-17-214L254-466l56-56 113 113 227-227 56 57-283 283Zm177 196v-240h80v109q55-45 87.5-109T800-480q0-123-80.5-212.5T520-797v-81q152 15 256 128t104 270q0 91-36.5 168T744-180h96v80H600Z" />
    </svg>
)

export const AddDatabase = () => (
    <svg width="22" height="22" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="path-1-inside-1_6038_23106" fill="white">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.89489 3.59766V8.09766V9.91429V13.2256C0.89489 13.2523 0.894519 13.2821 0.894111 13.3148L0.894111 13.3149C0.893164 13.391 0.892021 13.4829 0.89489 13.5872V14.4198C0.89489 16.7687 4.94536 17.9977 8.94752 17.9977C12.9497 17.9977 17.0002 16.7687 17.0002 14.4198V13.9261V13.4977V9.91429V8.09766V3.59766C15.3816 4.70999 12.683 5.49931 8.94752 5.49931C5.21199 5.49931 2.51347 4.70999 0.89489 3.59766Z" />
        </mask>
        <path d="M0.89489 3.59766L1.74446 2.36144L-0.60511 0.746741V3.59766H0.89489ZM0.894111 13.3148L-0.605773 13.2962L-0.605779 13.2967L0.894111 13.3148ZM0.894111 13.3149L2.394 13.3335L2.394 13.333L0.894111 13.3149ZM0.89489 13.5872H2.39489V13.5666L2.39432 13.5459L0.89489 13.5872ZM17.0002 3.59766H18.5002V0.746741L16.1506 2.36144L17.0002 3.59766ZM2.39489 8.09766V3.59766H-0.60511V8.09766H2.39489ZM2.39489 9.91429V8.09766H-0.60511V9.91429H2.39489ZM2.39489 13.2256V9.91429H-0.60511V13.2256H2.39489ZM2.394 13.3335C2.39437 13.3033 2.39489 13.2635 2.39489 13.2256H-0.60511C-0.60511 13.2411 -0.605334 13.2609 -0.605773 13.2962L2.394 13.3335ZM2.394 13.333V13.333L-0.605779 13.2967L-0.605779 13.2967L2.394 13.333ZM2.39432 13.5459C2.39237 13.475 2.39304 13.4104 2.394 13.3335L-0.605773 13.2962C-0.60671 13.3716 -0.60833 13.4908 -0.604543 13.6284L2.39432 13.5459ZM-0.60511 13.5872V14.4198H2.39489V13.5872H-0.60511ZM-0.60511 14.4198C-0.60511 16.5935 1.25328 17.8429 2.86673 18.4836C4.60689 19.1748 6.82089 19.4977 8.94752 19.4977V16.4977C7.072 16.4977 5.25968 16.2061 3.97406 15.6955C2.56174 15.1346 2.39489 14.5951 2.39489 14.4198H-0.60511ZM8.94752 19.4977C11.0742 19.4977 13.2882 19.1748 15.0283 18.4836C16.6418 17.8429 18.5002 16.5935 18.5002 14.4198H15.5002C15.5002 14.5951 15.3333 15.1346 13.921 15.6955C12.6354 16.2061 10.823 16.4977 8.94752 16.4977V19.4977ZM18.5002 14.4198V13.9261H15.5002V14.4198H18.5002ZM18.5002 13.9261V13.4977H15.5002V13.9261H18.5002ZM15.5002 9.91429V13.4977H18.5002V9.91429H15.5002ZM15.5002 8.09766V9.91429H18.5002V8.09766H15.5002ZM15.5002 3.59766V8.09766H18.5002V3.59766H15.5002ZM8.94752 6.99931C12.8591 6.99931 15.8935 6.17822 17.8497 4.83387L16.1506 2.36144C14.8696 3.24177 12.507 3.99931 8.94752 3.99931V6.99931ZM0.0453216 4.83387C2.0015 6.17822 5.03593 6.99931 8.94752 6.99931V3.99931C5.38806 3.99931 3.02544 3.24177 1.74446 2.36144L0.0453216 4.83387Z" fill="#44474A" mask="url(#path-1-inside-1_6038_23106)" />
        <path d="M8.94775 4.5C13.5959 4.5 15.8417 3.3246 16.6416 2.4615C15.5724 0.8424 12.2466 0 8.94775 0C5.64885 0 2.32312 0.8424 1.25391 2.4615C2.0538 3.3246 4.29959 4.5 8.94775 4.5Z" fill="#44474A" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.125 9H7.875V10.875H6V12.125H7.875V14H9.125V12.125H11V10.875H9.125V9Z" fill="#44474A" />
    </svg>
)